import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Redux slices 
import { setUserId } from './settingsSlice';
import { setSubPage2 } from '../menu/menuSlice';
import { setActivePage, setToken, setUser } from '../../appSlice';

// Components
import AjaxController from '../system/ajaxController';


/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// SemanticUI components
import { Table, TableHeader, TableHeaderCell, TableRow, TableBody, TableCell, Button, Header, HeaderContent, Icon, FormInput, TableFooter, Grid, GridRow, GridColumn, Form, FormGroup, FormField, FormSelect, Flag, Segment, Modal, Label, Container } from 'semantic-ui-react'

// Style
import './settings.css';

registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @returns 
 */
const Max2SettingsUsers = () => {
  // local state
  const [searchFilter, setSearchFilter]     = useState({});
  const [pagination, setPagination]         = useState({ recordsPerPage: 25, actualPage: 0, numberOfPages: 0})
  const [isSearching, setIsSearching]       = useState(false);
  const [isLoaded, setIsLoaded]             = useState(false);
  const [result, setResult]                 = useState({ numberOfRecordsTotal: 0, numberOfRecords: 0, records: [] });
  const [openModal, setOpenModal]           = useState(false);
  const [userDetails, setUserDetails]       = useState({});
  const [showPass, setShowPass]             = useState(false);
  const [showPassRepeat, setShowPassRepeat] = useState(false);
  const [unameError, setUnameError]         = useState(false);
  const [emailError, setEmailError]         = useState(false); 
  
  // global state
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  //
  const languageOptions = [ {key: 'german', value: 'german', text: 'Deutsch'}, {key: 'english', value: 'english', text: 'Englisch'}]

  //
  let content = <></>;
  let records = <></>;
  let loadMoreButton = <></>;
  



  /**
   * 
   * @param {string} column 
   * @param {mixed} value 
   */
  const handleFilterChange = (column, type, value ) => {
    let _filter = {...searchFilter };
    _filter[column] = { enabled: true, value: value, type: type };
    
    setSearchFilter(_filter)
  }



  /**
   * 
   */
  const handleResetFilterClick = () => {
    setSearchFilter({})
    loadUserData(true, true)
  }
  


  /**
   * 
   */
  const handleFilterClick = () => {
    loadUserData(true)
  }



  /**
   * 
   */
  const handleAddRecordClick = () => {
    setOpenModal(true);
  }



  const handleUnameChange = useCallback(async () => {

    // build request params
    const query = {
      filter:     {uname: { enabled: true, value: userDetails.uname, type: 0 }}, 
      pagination: pagination,
      sorting:    { by: 'uname', direction: 'ASC' }
    }

    const cleanString = (str) => {
      // 1. Deutsche Umlaute und ß gezielt umschreiben
      str = str
        .replace(/ä/g, "ae")
        .replace(/ö/g, "oe")
        .replace(/ü/g, "ue")
        .replace(/Ä/g, "Ae")
        .replace(/Ö/g, "Oe")
        .replace(/Ü/g, "Ue")
        .replace(/ß/g, "ss");

      // 2. Unicode-Normalisierung (z. B. é → e +  ́)
      str = str.normalize("NFD");

      // 3. Diakritische Zeichen entfernen (Akzente, Punkte, Striche usw.)
      str = str.replace(/[\u0300-\u036f]/g, "");

      // 4. Alles, was nicht alphanumerisch ist, löschen
      return str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    }

    // bereinigen
    setUserDetails({...userDetails, uname: cleanString(userDetails.uname)})

    // reset input error flag
    setUnameError(false);

    // check length
    if (userDetails.uname.length < 3) {
      enqueueSnackbar('Benutzername muss aus mindestend drei Zeichen besteghen', { variant: 'error' });
      setUnameError(true);
      return;
    }

    // search for users with current uname
    try {

      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });
      
      // send search request
      const response = await api.get('/settings/user_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      console.log('[response?.records]', response?.records)
      
      // validate respone
      response?.records.forEach(user => {
        if (user.uname === userDetails.uname) {
          enqueueSnackbar('Benutzername bereits vergeben', { variant: 'error' });
          setUnameError(false);
        }
        return;
      });

      enqueueSnackbar('Benutzername verfügbar', { variant: 'success' });
      setEmailError(false);
    } catch (err) {
      console.error(err.message);
    }
  }, [backendUrl, enqueueSnackbar, pagination, userDetails, dispatch, setUserDetails]);



  const handleEmailChange = useCallback(async () => {
    // build request params
    const query = {
      filter:     {uname: { enabled: true, value: userDetails.uname, type: 0 }}, 
      pagination: pagination,
      sorting:    { by: 'uname', direction: 'ASC' }
    }

    // reset input error flag
    setEmailError(false);

    // search for users with current email
    try {
      
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });
      
      // send search request
      const response = await api.get('/settings/user_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      console.log('[response?.records]', response?.records)
      
      // validate respone
      response?.records.forEach(user => {
        if (user.uname === userDetails.uname) {
          enqueueSnackbar('Email-Adresse bereits in Verwenundung', { variant: 'error' });
          setEmailError(false);
        }
        return;
      });

      enqueueSnackbar('Email-Adresse verfügbar', { variant: 'success' });
      setEmailError(false);
    } catch (err) {
      console.error(err.message);
    }
  }, [backendUrl, enqueueSnackbar, pagination, userDetails, dispatch]);



  /**
   * 
   * @param {integer} uid 
   */
  const handleRowClick = (uid, name) => {
    dispatch(setSubPage2(name));
    dispatch(setUserId(uid));
  }



  const handleApplyAddUserClick = async () => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // send post request
      const response = await api.post('/settings/user/new', userDetails);
      if (response?.status === 'success') {
        enqueueSnackbar('Benutzer wurde angelegt', { variant: 'success' });
        const _uname = userDetails.uname;
        setUserDetails({});
        handleRowClick(response.uid, _uname);
      }
    } catch (err) {
      enqueueSnackbar('Fehler beim Anlegen des Benutzers', { variant: 'error' });
      console.error(err.message);
    }
  }
  


  /**
   * AJAX API request
   */
  const fetchData = useCallback(async (query, initial, resetFilter) => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // show loading animation
      setIsSearching(true);

      // send search request
      const count = await api.get('/settings/user_count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      const response = await api.get('/settings/user_filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      
      // display results
      if (response?.records.length) {
        let _records = [...result.records];
        let numberOfRecords = result.numberOfRecords  + response.records.length;

        // reset state result object on filter 
        if (initial) {
          _records = [];
          numberOfRecords = response.records.length;
        }
        
        // add records to state result object
        response.records.forEach(record => {
          _records.push(record);
        });

        // assemble result object
        const _result = {
          records: _records,
          numberOfRecordsTotal: count, 
          numberOfRecords: numberOfRecords
        }
        
        // set result and pagination
        setResult(_result)
        setPagination(query.pagination)
      }

      // hide loading animation
      setIsLoaded(true);
      setIsSearching(false);
      if (resetFilter) {
        setSearchFilter({});
      }

    } catch (err) {
      //setError(err.message);
      console.error(err.message);
      setIsLoaded(true);
      setIsSearching(false);
      setSearchFilter({});
    }
  }, [backendUrl, dispatch, result.records, result.numberOfRecords]);


  
  /**
   * 
   */
  const loadUserData = useCallback((initial = false, resetFilter = false) => {
    let actualPage = initial ? 1 : pagination.actualPage + 1;

    // build request params
    const query = {
      filter:     searchFilter, 
      pagination: {
        ...pagination,
        actualPage: actualPage
      },
      sorting:    { by: 'uname', direction: 'ASC' }
    }
    
    // run request
    fetchData(query, initial, resetFilter);
  }, [fetchData, pagination, searchFilter]);



  /**
   * Initialize user list
   */
  useEffect(() => {
    if (!isLoaded) {
      loadUserData(true);
    }
  }, [isLoaded, loadUserData]);
  
  // Show placeholder while getting data 
  if (isSearching) {
    content = (
      <>
      <Header as='h4'>Filter</Header>
      <Header as='h2' textAlign='center'>
        <Icon loading name='spinner' />
        <HeaderContent>
          Datenbank wird durchsucht
        </HeaderContent>
      </Header>
      </>
    )
  }

  // build content table 
  if (result?.records.length) {

    // build records list  
    records = result?.records.map((record, recordIndex) => {
      const ll    = record.last_login ? format(new Date(record.last_login * 1000), 'dd.MM.yyyy HH:mm:ss') : '';
      const rd    = record.last_login ? format(new Date(record.user_regdate * 1000), 'dd.MM.yyyy HH:mm:ss') : '';
      const flag  = record.language === 'german' ? <Flag name='de' /> : <Flag name='uk' />
      return (
        <TableRow key={recordIndex} style={{cursor: 'pointer'}} onClick={()=>handleRowClick(record.uid, record.uname)}>
          <TableCell>{record.name}</TableCell>
          <TableCell>{record.uname}</TableCell>
          <TableCell>{record.email}</TableCell>
          <TableCell>{ll}</TableCell>
          <TableCell>{rd}</TableCell>
          {/*<TableCell>{flag}</TableCell>*/}
          <TableCell></TableCell>
        </TableRow>
      )
    })

    // build load more button
    loadMoreButton = parseInt(result.numberOfRecords) < parseInt(result.numberOfRecordsTotal) ? <Button basic circular onClick={() => loadUserData()}>mehr...</Button> : <></>;
  }

  // Build table
  if (!isSearching) {
    content = (
       <div style={{ minWidth: 'calc(100vw - 160px)', maxHeight: "calc(100vh - 500px)", overflowY: "auto" }}>
        <Table basic='very' singleLine collapsing selectable fixed>
          <TableHeader>
            <TableRow>
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>Name</TableHeaderCell>
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>Benutzername</TableHeaderCell>
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>E-Mail</TableHeaderCell>
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>letzer Login</TableHeaderCell>
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>Registrierdatum</TableHeaderCell>
              {/*<TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }}>Sprache</TableHeaderCell>*/}
              <TableHeaderCell style={{ position: "sticky", top: 0, zIndex: 2, background: "white" }} collapsing>
                <Button primary circular icon='add' onClick={() => handleAddRecordClick()} />
              </TableHeaderCell>
            </TableRow>
          </TableHeader>

          <TableBody>
            {records}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell textAlign='center' colSpan={6}>
                {loadMoreButton}
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    );
  }

  // Build modal password fields
  const inputPass = showPass 
  ? <FormInput fluid label="Passwort"     value={userDetails?.pass} action={{content: 'verstecken', onClick: () => setShowPass(false)}} icon='key' iconPosition='left' onChange = {(e, data) => setUserDetails({...userDetails, pass: data.value})} />
  : <FormInput fluid label="Passwort"     value={userDetails?.pass} action={{content: 'anzeigen',   onClick: () => setShowPass(true)}}  icon='key' iconPosition='left' onChange = {(e, data) => setUserDetails({...userDetails, pass: data.value})} type='password' />
  
  const inputPassRepeat = showPassRepeat 
  ? <FormInput fluid label="Wiederholung" value={userDetails?.pass_repeat} action={{content: 'verstecken', onClick: () => setShowPassRepeat(false)}} icon='key' iconPosition='left' onChange = {(e, data) => setUserDetails({...userDetails, pass_repeat: data.value})} />
  : <FormInput fluid label="Wiederholung" value={userDetails?.pass_repeat} action={{content: 'anzeigen',   onClick: () => setShowPassRepeat(true)}}  icon='key' iconPosition='left' onChange = {(e, data) => setUserDetails({...userDetails, pass_repeat: data.value})} type='password' />

  return (
    <>
    <Modal  size="large" open={openModal} onClose={()=>setOpenModal(false)}>
      <Modal.Header>Neuen Benutzer anlegen</Modal.Header>
      <Modal.Content>
        <Segment textAlign='left' style={{ margin: '20px' }}>
          <Label circular style={{marginBottom: '20px', background: 'transparent'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Details</span></Label>
          <Container>
            <Form>
              <Form>
                {unameError 
                  ? <FormInput fluid label="Benutzername" value={userDetails.uname} onChange = {(e, data) => setUserDetails({...userDetails, uname: data.value})} onBlur = {() => handleUnameChange()} error />
                  : <FormInput fluid label="Benutzername" value={userDetails.uname} onChange = {(e, data) => setUserDetails({...userDetails, uname: data.value})} onBlur = {() => handleUnameChange()} />
                }
                {emailError 
                  ? <FormInput fluid label="E-Mail"             value={userDetails.email} onChange = {(e, data) => setUserDetails({...userDetails, email: data.value})} onBlur = {() => handleEmailChange()} error />
                  : <FormInput fluid label="E-Mail"             value={userDetails.email} onChange = {(e, data) => setUserDetails({...userDetails, email: data.value})} onBlur = {() => handleEmailChange()} />
                }
                <FormGroup widths='equal'>
                    {inputPass}
                    {inputPassRepeat}
                </FormGroup>
                <br /><br />
                <FormInput fluid label="Anzeigename"        value={userDetails.displayname} onChange = {(e, data) => setUserDetails({...userDetails, displayname: data.value})} />
                <FormGroup widths='equal'>
                  <FormInput fluid label="Vorame"           value={userDetails.forename} onChange = {(e, data) => setUserDetails({...userDetails, forename: data.value})} />
                  <FormInput fluid label="Nachname"         value={userDetails.surename} onChange = {(e, data) => setUserDetails({...userDetails, surename: data.value})} />
                </FormGroup>
                <FormInput fluid label="Telefon"            value={userDetails.telephone} onChange = {(e, data) => setUserDetails({...userDetails, telephone: data.value})} />
                {/*<FormSelect fluid label="Anzeigesprache"    value={userDetails.language} options={languageOptions} onChange = {(e, data) => setUserDetails({...userDetails, language: data.value})} />*/}
              </Form>
            </Form>
          </Container>
        </Segment>
      </Modal.Content>
      <Modal.Actions>
        <Button basic circular icon labelPosition='left' onClick={() => setOpenModal(false)}><Icon name='times' />Schließen</Button>
        <Button primary circular icon labelPosition='left' onClick={() => handleApplyAddUserClick()}><Icon name='add' />anlegen</Button>
      </Modal.Actions>
    </Modal>


    <Grid style={{margin: '25px'}}>
      <GridRow> 
        <GridColumn width={16}>
          <Segment style={{backgroundColor: '#f5f5f5'}}>
            <Header as='h4'>Filter</Header>
            <Form>
              <FormGroup>
                <FormInput label="Name"         value={searchFilter?.name?.value} onChange = {(e, data) => handleFilterChange('name', 0, data.value)} />
                <FormInput label="Benutzername" value={searchFilter?.uname?.value} onChange = {(e, data) => handleFilterChange('uname', 0, data.value)} />
                <FormInput label="E-Mail"       value={searchFilter?.email?.value} onChange = {(e, data) => handleFilterChange('email', 0, data.value)} />
                <FormField>
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected    = {searchFilter.lastloginStart?.value}
                  startDate   = {searchFilter.lastloginStart?.value}
                  endDate     = {searchFilter.lastloginEnd?.value}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => { handleFilterChange('lastloginStart', 1, format(date, "yyyy-MM-dd")) }}
                  customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="Letzer Login von" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected    = {searchFilter.lastloginEnd?.value}
                  startDate   = {searchFilter.lastloginStart?.value}
                  endDate     = {searchFilter.lastloginEnd?.value}
                  minDate     = {searchFilter.lastloginStart?.value}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => { handleFilterChange('lastloginEnd', 1, format(date, "yyyy-MM-dd")) }}
                  customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="bis" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
                </FormField>

                <FormField>
                <DatePicker
                  showWeekNumbers
                  selectsStart
                  selected    = {searchFilter.registeredStart?.value}
                  startDate   = {searchFilter.registeredStart?.value}
                  endDate     = {searchFilter.registeredEnd?.value}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => { handleFilterChange('registeredStart', 1, format(date, "yyyy-MM-dd")) }}
                  customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="Registrierung von" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
                <DatePicker
                  showWeekNumbers
                  selectsEnd
                  selected    = {searchFilter.registeredEnd?.value}
                  startDate   = {searchFilter.registeredStart?.value}
                  endDate     = {searchFilter.registeredEnd?.value}
                  minDate     = {searchFilter.registeredStart?.value}
                  dateFormat  = "dd.MM.yyyy"
                  placeholder = 'TT.MM.JJJJ'
                  onChange    = {(date) => { handleFilterChange('registeredEnd', 1, format(date, "yyyy-MM-dd")) }}
                  customInput = {<FormInput icon='calendar alternate' iconPosition='left' label="bis" placeholder='TT.MM.JJJJ' style={{width: "130px"}} />}
                />
                </FormField>
                <FormField style={{paddingTop: '25px'}}>
                  <Button primary circular icon labelPosition='left' onClick={()=>handleFilterClick()}><Icon name="filter" /> Filtern</Button>
                  <Button basic circular icon='times' onClick={() => handleResetFilterClick()} />
                </FormField>  
              </FormGroup>
            </Form>
          </Segment>

        </GridColumn>
      </GridRow>
      <GridRow>
        <GridColumn width={6}>
          <Header as='h4'>Benutzerliste ({result.numberOfRecords} von {result.numberOfRecordsTotal})</Header>
          {content}
        </GridColumn>
      </GridRow>
    </Grid>
    </>
  )
}

export default Max2SettingsUsers;